import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "blocker-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12 2.25012C6.61479 2.25012 2.25 6.61491 2.25 12.0001C2.25 17.3853 6.61479 21.7501 12 21.7501C17.3852 21.7501 21.75 17.3853 21.75 12.0001C21.75 6.61491 17.3852 2.25012 12 2.25012ZM3.75 12.0001C3.75 7.44334 7.44321 3.75012 12 3.75012C14.0082 3.75012 15.8487 4.46745 17.2793 5.65989L5.65976 17.2794C4.46733 15.8489 3.75 14.0084 3.75 12.0001ZM6.7204 18.3401C8.151 19.5327 9.99162 20.2501 12 20.2501C16.5568 20.2501 20.25 16.5569 20.25 12.0001C20.25 9.99175 19.5326 8.15113 18.34 6.72052L6.7204 18.3401Z"
    }, null, -1)
  ])))
}
export default { render: render }